import PropTypes from 'prop-types';

export default {
  selected: PropTypes.object.isRequired,
  copied: PropTypes.object,
  dragged: PropTypes.object,
  onCellClick: PropTypes.func.isRequired,
  onCellDoubleClick: PropTypes.func.isRequired,
  onCommit: PropTypes.func.isRequired,
  onCommitCancel: PropTypes.func.isRequired,
  handleDragEnterRow: PropTypes.func.isRequired,
  handleTerminateDrag: PropTypes.func.isRequired,
  getCellActions: PropTypes.func,
};

export type ICellMetaDataShape = {
  selected: any;
  copied?: any;
  dragged?: any;
  onCellClick: Function;
  onCellDoubleClick: Function;
  onCommit: Function;
  onCommitCancel: Function;
  onCellFocus?: Function;
  onCellContextMenu?: Function;
  handleDragEnterRow: Function;
  handleTerminateDrag: Function;
  getCellActions?: Function;
  onCellExpand?: Function;
  onDeleteSubRow?: Function;
  onDragHandleDoubleClick?: Function;
  enableCellSelect?: boolean;
  getDataGridDOMNode?: () => any;
  isScrollingVerticallyWithKeyboard?: boolean;
  isScrollingHorizontallyWithKeyboard?: boolean;
  enableCellAutoFocus?: boolean;
  onColumnEvent?: any;
  rowKey?: string;
};
